import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api';
import {
  MetricsQueryParams,
  CompanyMetricsResponse,
} from './companyMetrics.types';

const companyOffersApiPath = (companyId: string) =>
  `/companies/${companyId}/metrics`;

export const getMetrics = async ({
  companyId,
  params,
}: {
  companyId: string;
  params?: MetricsQueryParams;
}): Promise<AxiosResponse<CompanyMetricsResponse & ApiError>> => {
  return instance
    .get<CompanyMetricsResponse>(companyOffersApiPath(companyId), { params })
    .catch((e) => e.response as AxiosError<ApiError> as never);
};
